import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router, RoutesRecognized } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

export enum Layouts {
  HomeLayout,
  FullscreenLayout,
}

@Component({
  selector: 'app-flexible-layout',
  templateUrl: './flexible-layout.component.html',
  styleUrls: ['./flexible-layout.component.scss']
})
export class FlexibleLayoutComponent implements OnInit, OnDestroy {
  Layouts = Layouts;
  layout: Layouts;
  termination = new Subject<boolean>();
  isMenuHidden = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.layout = this.route.snapshot.firstChild.data.layout || Layouts.HomeLayout;
    this.isMenuHidden = this.route.snapshot.firstChild.data.hideMenu ?? false;

    this.router.events
    .pipe(
      takeUntil(this.termination)
    )
    .subscribe(data => {
      if (data instanceof RoutesRecognized) {
        const baseComponent = this.getBaseComponent(data.state.root.firstChild);
        this.layout = baseComponent.data.layout || Layouts.HomeLayout;
      }
    });
  }

  ngOnDestroy() {
     console.log('destroying');
    
    this.termination.next(true);
    this.termination.complete();
  }

  getBaseComponent(component: ActivatedRouteSnapshot) {
    if (component.firstChild) {
      return this.getBaseComponent(component.firstChild);
    }

    return component;
  }

}
